import { createSlice } from "@reduxjs/toolkit";
import { fetchProjectManagerDistrictInchargeMapping } from "./thunk";

interface PRState {
  list: any[];
  rowCount: number;
  loading: boolean;
  error: string | null;
}

const initialState: PRState = {
  list: [],
  rowCount: 0,
  loading: false,
  error: null,
};

const ProjectManagerDistrictInchargeMappingSlice = createSlice({
  name: "ProjectManagerDistrictInchargeMapping",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchProjectManagerDistrictInchargeMapping.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchProjectManagerDistrictInchargeMapping.fulfilled, (state, action) => {
        state.loading = false;
        state.list = action.payload.data;
        state.rowCount = action.payload.rowCount;
      })
      .addCase(fetchProjectManagerDistrictInchargeMapping.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to fetch ProjectManager DistrictIncharge Mapping List";
      });
  },
});

export default ProjectManagerDistrictInchargeMappingSlice.reducer;
